import type { ThemeWithoutTokens } from '../theme.types';

export const coloredCardTokens = (theme: ThemeWithoutTokens) =>
  ({
    coloredCardPaddingX: theme.space.component.x.m,
    coloredCardPaddingY: theme.space.component.y.m,
    coloredCardRadius: theme.radiuses.m,

    // TODO: use theme.colors instead of theme.palette

    // variants:
    // blue
    coloredCardBlueBackgroundColor: theme.colors.primary.light,
    coloredCardBlueTextColor: theme.colors.primary.textDark,
    coloredCardBlueButtonTextColor: theme.colors.body.textLight,
    coloredCardBlueButtonBackgroundColor: theme.colors.primary.normal,
    coloredCardBlueButtonHoverBackgroundColor: theme.colors.primary.dark,
    coloredCardBlueButtonFocusBackgroundColor: theme.colors.primary.darker,
    coloredCardBlueIconTextColor: theme.colors.primary.textRegular,

    // red
    coloredCardRedBackgroundColor: theme.colors.danger.light,
    coloredCardRedTextColor: theme.colors.danger.textDark,
    coloredCardRedButtonTextColor: theme.colors.body.textLight,
    coloredCardRedButtonBackgroundColor: theme.colors.danger.normal,
    coloredCardRedButtonHoverBackgroundColor: theme.colors.danger.dark,
    coloredCardRedButtonFocusBackgroundColor: theme.colors.danger.darker,
    coloredCardRedIconTextColor: theme.colors.danger.textRegular,

    // green
    coloredCardGreenBackgroundColor: theme.colors.success.light,
    coloredCardGreenTextColor: theme.colors.success.textDark,
    coloredCardGreenButtonTextColor: theme.colors.body.textLight,
    coloredCardGreenButtonBackgroundColor: theme.colors.success.normal,
    coloredCardGreenButtonHoverBackgroundColor: theme.colors.success.dark,
    coloredCardGreenButtonFocusBackgroundColor: theme.colors.success.darker,
    coloredCardGreenIconTextColor: theme.colors.success.textRegular,

    // orange
    coloredCardOrangeBackgroundColor: theme.colors.warning.light,
    coloredCardOrangeTextColor: theme.colors.warning.textDark,
    coloredCardOrangeButtonTextColor: theme.colors.body.textLight,
    coloredCardOrangeButtonBackgroundColor: theme.colors.warning.normal,
    coloredCardOrangeButtonHoverBackgroundColor: theme.colors.warning.dark,
    coloredCardOrangeButtonFocusBackgroundColor: theme.colors.warning.darker,
    coloredCardOrangeIconTextColor: theme.colors.warning.textRegular,

    // purple
    coloredCardPurpleBackgroundColor: theme.palette.purple50,
    coloredCardPurpleTextColor: theme.palette.purple700,
    coloredCardPurpleButtonTextColor: theme.colors.body.textLight,
    coloredCardPurpleButtonBackgroundColor: theme.palette.purple400,
    coloredCardPurpleButtonHoverBackgroundColor: theme.palette.purple500,
    coloredCardPurpleButtonFocusBackgroundColor: theme.palette.purple600,
    coloredCardPurpleIconTextColor: theme.palette.purple400,

    // yellow
    coloredCardYellowBackgroundColor: theme.palette.yellow50,
    coloredCardYellowTextColor: theme.palette.yellow700,
    coloredCardYellowButtonTextColor: theme.colors.body.textLight,
    coloredCardYellowButtonBackgroundColor: theme.palette.yellow400,
    coloredCardYellowButtonHoverBackgroundColor: theme.palette.yellow500,
    coloredCardYellowButtonFocusBackgroundColor: theme.palette.yellow600,
    coloredCardYellowIconTextColor: theme.palette.yellow400,
  }) as const;
